// extracted by mini-css-extract-plugin
export default {"myDrafts__deleteModal":"MyDrafts__myDrafts__deleteModal__AIV03","myDrafts__deleteModal__text":"MyDrafts__myDrafts__deleteModal__text__7CRoW"};